import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectEmailTemplateCategories = createSelector(
  getSystem,
  ({ emailTemplateCategories }) => emailTemplateCategories,
);
export const selectEmailTemplateCategoriesArray = createSelector(
  selectEmailTemplateCategories,
  Object.values,
);
